// extracted by mini-css-extract-plugin
export default {"modal":"_2KGdR_WznzUyIg-kcNCJlN"};